import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取提单预报列表
export const getBillForecastList = (params) => {
  return axios.request({
    url: "/warehouse/prediction/index",
    method: "get",
    params,
  });
};

// 获取配置
export const getConfig = (params) => {
  return axios.request({
    url: "/warehouse/prediction/conf",
    method: "get",
    params,
  });
};

// 获取备注列表
export const getRemarkList = (params) => {
  return axios.request({
    url: "/warehouse/prediction/remarks/" + params.id,
    method: "get",
  });
};

// 新增备注
export const addRemark = (data) => {
  return axios.request({
    url: "/warehouse/prediction/remarks/" + data.id,
    method: "post",
    data,
  });
};
// 删除备注
export const delRemark = (id) => {
  return axios.request({
    url: "/warehouse/prediction/remarks/" + id,
    method: "delete",
  });
};

// 导出
export const exportExcel = (params) => {
  return axios.request({
    url: "/warehouse/prediction/export",
    method: "get",
    params,
  });
};

// 同步数据
export const syncData = (data) => {
  return axios.request({
    url: "/warehouse/prediction/sync",
    method: "post",
    data,
  });
};

export const getAliData = (data) => {
  return axios.request({
    url: "/warehouse/alibaba",
    method: "post",
    data,
  });
};
